module.exports = __webpack_public_path__ + "static/media/model.d937cf57.svg";